// extracted by mini-css-extract-plugin
export var locationCard = "_gi-0";